import { Image, Layout, Menu, message } from "antd";
import React, { useEffect } from "react";
import {
  MessageOutlined,
  UserOutlined,
  VideoCameraOutlined,
  AppstoreOutlined,
  TransactionOutlined,
  LogoutOutlined,
  ContainerOutlined,
  NotificationOutlined,
  CreditCardOutlined,
  UnorderedListOutlined,
  MoneyCollectOutlined,
  LeftOutlined,
  RightOutlined,
  BookOutlined
} from "@ant-design/icons";
import { Button } from "antd";
import logo from "../assets/icon/logo.png"
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
const { Sider } = Layout;


export default function CustomeSider({
  mobile = false,
  onNavigate
}) {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(['admin']);
  const [collapsed, setCollapsed] = React.useState(false);

  const menuItem = [
    {
      key: "dashboard",
      icon: <AppstoreOutlined />,
      label: <Link to={"/admin"}>Bảng tin</Link>,
    },
    {
      key: "user",
      icon: <UserOutlined />,
      label: <Link to={"/admin/quan-ly-nguoi-dung"}>Quản lý người dùng</Link>,
    },
    {
      key: "category",
      icon: <AppstoreOutlined />,
      label: "Quản lý danh mục",
      children: [
        {
          key: "categoryIndex",
          label: <Link to={"/admin/quan-ly-danh-muc-trang-chu"}>Danh mục trang chủ</Link>,
        },
        {
          key: "categoryParent",
          label: <Link to={"/admin/quan-ly-danh-muc"}>Danh mục cha</Link>,
        },
        {
          key: "categoryChild",
          label: <Link to={"/admin/quan-ly-danh-muc-con"}>Danh mục con</Link>,
        },
      ],
    },
    {
      key: "product",
      icon: <VideoCameraOutlined />,
      label: "Quản lý sản phẩm",
      children: [
        {
          key: "attributeManage",
          label: <Link to={"/admin/quan-ly-thuoc-tinh"}>Quản lý thuộc tính</Link>,
        },
        {
          key: "productManage",
          label: <Link to={"/admin/quan-ly-san-pham"}>Quản lý sản phẩm</Link>,
        },
      ],
    },
    {
      key: "indexManage",
      icon: <VideoCameraOutlined />,
      label: <Link to={"/admin/quan-ly-trang-chu"}>Quản lý trang chủ</Link>,
    },
    {
      key: "wareHouseManage",
      icon: <VideoCameraOutlined />,
      label: <Link to={"/admin/quan-ly-kho-hang"}>Quản lý kho hàng</Link>,
    },
    {
      key: "orderManage",
      icon: <VideoCameraOutlined />,
      label: <Link to={"/admin/quan-ly-don-hang"}>Quản lý đơn hàng</Link>,
    },
    {
      key: "pendingOrderManage",
      icon: <NotificationOutlined />,
      label: (
        <Link to={"/admin/don-hang-chua-xac-nhan"}>
          Đơn chưa xác nhận
        </Link>
      ),
    },
    {
      key: "paymentAudit",
      icon: <CreditCardOutlined />,
      label: (
        <Link to={"/admin/kiem-tra-chuyen-khoan"}>
          Kiểm tra chuyển khoản
        </Link>
      ),
    },
    {
      key: "paymentSettings",
      icon: <CreditCardOutlined />,
      label: (
        <Link to={"/admin/tai-khoan-thanh-toan"}>
          Tài khoản thanh toán
        </Link>
      ),
    },
    {
      key: "categoryBlogManage",
      icon: <UnorderedListOutlined />,
      label: <Link to={"/admin/quan-ly-danh-muc-blog"}>Quản lý danh mục Blog</Link>,
    },
    {
      key: "blogManage",
      icon: <UnorderedListOutlined />,
      label: <Link to={"/admin/quan-ly-blog"}>Quản lý Blog</Link>,
    },
    {
      key: "osBooks",
      icon: <BookOutlined />,
      label: <Link to={"/admin/os-books"}>OS BOOKS</Link>,
    },
    {
      key: "pushNotification",
      icon: <NotificationOutlined />,
      label: <Link to={"/admin/thong-bao-day"}>Thông báo đẩy</Link>,
    },
    {
      key: "emailMkt",
      icon: <UnorderedListOutlined />,
      label: <Link to={"/admin/quan-ly-email-mkt"}>Quản lý Email MKT</Link>,
    },
    {
      key: "voucherManage",
      icon: <CreditCardOutlined />,
      label: <Link to={"/admin/quan-ly-ma-giam-gia"}>Quản lý voucher</Link>,
    },
    {
      key: "commentManage",
      icon: <UnorderedListOutlined />,
      label: <Link to={"/admin/quan-ly-comment"}>Quản lý bình luận</Link>,
    },
    {
      key: "makeMoneyManage",
      icon: <UnorderedListOutlined />,
      label: <Link to={"/admin/quan-ly-make-money"}>Quản lý nhiệm vụ</Link>,
    },
    {
      key: "refundMoneyManage",
      icon: <UnorderedListOutlined />,
      label: <Link to={"/admin/quan-ly-refund-money"}>Quản lý hoàn tiền</Link>,
    },
    {
      key: "rqMakeMoneyManage",
      icon: <UnorderedListOutlined />,
      label: <Link to={"/admin/quan-ly-rq-make-money"}>Quản lý nộp nhiệm vụ</Link>,
    },
    {
      key: "requestMoneyManage",
      icon: <MoneyCollectOutlined />,
      label: <Link to={"/admin/quan-ly-request-money"}>Quản lý rút tiền</Link>,
    },
    {
      key: "requestRefundMoneyManage",
      icon: <MoneyCollectOutlined />,
      label: <Link to={"/admin/quan-ly-rq-refund-money"}>Quản lý rút hoàn tiền</Link>,
    },
    {
      key: "iframeSettings",
      icon: <UnorderedListOutlined />,
      label: <Link to={"/admin/cau-hinh-iframe"}>Cấu hình Iframe</Link>,
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: <Link to={"/dang-nhap-admin"} onClick={() => {
        removeCookie("admin");
        localStorage.removeItem('admin_token');
        localStorage.removeItem('token');
      }}>
        Thoát
      </Link>,
    },
  ];

  useEffect(() => {
    if (!cookies?.admin) {
      removeCookie("admin");
      localStorage.removeItem('admin_token');
        localStorage.removeItem('token');
      navigate("/dang-nhap-admin");
      message.warning("Bạn vui lòng đăng nhập bằng tài khoản của Admin!")
    }
  }, []);

  return (
    <div
      className={
        mobile
          ? "!bg-white h-full relative"
          : "!bg-white border-r border-gray-200 h-full relative"
      }
    >
      <Sider
        width={mobile ? "100%" : 220}
        breakpoint={mobile ? undefined : "lg"}
        collapsedWidth="0"
        collapsible={!mobile}
        collapsed={mobile ? false : collapsed}
        trigger={null}
        zeroWidthTriggerStyle={{ display: 'none' }}
        onCollapse={(value) => {
          if (!mobile) {
            setCollapsed(value);
          }
        }}
        className="!w-full !bg-white"
      >
        <div className="flex justify-center py-5">
          <Link to={"/admin"}>
            <Image
              preview={false}
              src={logo}
              width={50}
              height={50}
            />
          </Link>
        </div>
        <div className="flex items-center px-5 mb-2 border">
          <Image
            preview={false}
            src={cookies.admin?.photos}
            width={30}
            height={30}
          />
          <div className="ml-[10px] font-bold">
            {cookies.admin?.displayName}
          </div>
        </div>
        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={menuItem}
          onClick={() => {
            if (mobile && onNavigate) {
              onNavigate();
            }
          }}
          style={{
            borderInlineEnd: 0,
            fontSize: mobile ? 14 : undefined
          }}
        />
      </Sider>
      {!mobile && (
        <Button
          className="flex items-center justify-center border border-gray-200 shadow-sm bg-white hover:text-blue-600 transition-colors"
          shape="circle"
          icon={
            collapsed
              ? <RightOutlined className="text-[10px]" />
              : <LeftOutlined className="text-[10px]" />
          }
          onClick={() => setCollapsed(!collapsed)}
          style={{
            position: 'absolute',
            top: '16px',
            right: '-12px',
            zIndex: 1000,
            width: '24px',
            height: '24px',
            minWidth: '24px',
            padding: 0
          }}
        />
      )}
    </div>
  );
}
